import request from '@/utils/request'

/**
 * 获取体系列表(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthSystemEntityList(data) {
  return request({
    type: 'base',
    url: 'oauth/system/entity/list',
    method: 'post',
    data
  })
}
/**
 * 获取体系下人员列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthSystemMemberList(data) {
  return request({
    type: 'base',
    url: 'oauth/system/member/list',
    method: 'post',
    data
  })
}
/**
 * 新增体系信息,体系无负责人,无上级
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function systemAdd(data) {
  return request({
    type: 'base',
    url: 'system/add',
    method: 'post',
    data
  })
}
/**
 * 删除体系信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function systemDelete(data) {
  return request({
    type: 'base',
    url: 'system/delete',
    method: 'post',
    data
  })
}
/**
 * 获取体系信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function systemListGet(data) {
  return request({
    type: 'base',
    url: 'system/list/get',
    method: 'post',
    data
  })
}
/**
 * 编辑体系信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function systemUpdate(data) {
  return request({
    type: 'base',
    url: 'system/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/System.js